import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import "./Header.css";
import MailerLite from '../components/MailerLite';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (

    <header className="header">
      <div class="header_container">
        <div class="logo">
          <span onClick={() => handleClick('/')}>
            <img height="100px" src="images/banner2_full.png" alt="Adventure Fantasy by Michael Goe" className="header_image" />
          </span>

          {/* <div class="logo_l">
            <span onClick={() => handleClick('/')}>
              <img height="100px" src="images/banner1_l.png" alt="Titan by Michael Goe" className="header_image" />
            </span>
          </div>
          <div class="logo_r">
            <img height="100px" src="images/banner1_r.png" alt="Titan by Michael Goe" className="header_image" />

          </div> */}
        </div>

        <nav className={`header_nav ${menuOpen ? 'header_nav--open' : ''}`}>
          <ul className="header_menu">
            <li className="header_item"><span onClick={() => handleClick('/')}>Home</span></li>
            <li className="header_item"><span className="header_bullet">•</span></li>
            <li className="header_item"><span onClick={() => handleClick('/about')}>About</span></li>
            <li className="header_item"><span className="header_bullet">•</span></li>
            <li className="header_item"><span onClick={() => handleClick('/books')}>Books</span></li>
            {/* <li classname="header_item"><MailerLite /></li> */}
          </ul>
        </nav>
        {/* i've commented out the mobile hamburger menu for now in an effort to simplify the mobile site -mg
         <button className="header__toggle" onClick={toggleMenu}>
          ☰
        </button>
        
        */}

      </div>
    </header>
  );
};

export default Header;
